import { type FC, useMemo } from "react";

import { DropdownWrapper } from "../../dropdowns";
import { PriorityLevels, ReadOnlyEmptyStates } from "../../../enums";

import "./priorityLevelDropdown.scss";
import { getPriorityLevels } from "../priorityLevel/getPriorityLevels";
import { ValidatedForm } from "components/forms";

interface Props {
  priorityLevel?: PriorityLevels;
  onChange?: (priorityLevel: PriorityLevels) => void;
  disableDefault?: boolean;
  disabled?: boolean;
  isReadOnlyView?: boolean;
}

const PriorityLevelDropdown: FC<Props> = ({
  priorityLevel = PriorityLevels.none,
  onChange,
  disableDefault,
  disabled,
  isReadOnlyView,
}) => {
  const options = useMemo(() => {
    return getPriorityLevels(disableDefault);
  }, [disableDefault]);

  if (isReadOnlyView) {
    return (
      <ValidatedForm.DropdownField
        label="Priority Level"
        value={priorityLevel !== 0 ? priorityLevel : undefined}
        options={options}
        className="empty-state-priority-level-dropdown"
        isReadOnlyView={isReadOnlyView}
        readOnlyEmptyState={ReadOnlyEmptyStates.None}
      />
    );
  }

  return (
    <DropdownWrapper
      blur
      items={options}
      id="priority-level-dropdown"
      className="priority-level-dropdown"
      selection
      value={priorityLevel}
      handleOptionChange={(e, data) => onChange?.(data.value as PriorityLevels)}
      disabled={disabled}
    />
  );
};

export default PriorityLevelDropdown;
